/* PP · Herkunfts-Frage (Verhalten) – speichert die Antwort auf „Wie haben Sie uns gefunden?“ als Warenkorb-Attribut (/cart/update.js),
   zeigt danach leise „Danke!“ (Platz ist im Kasten reserviert → nichts springt). Fehler werden still geschluckt: der Warenkorb wird nie blockiert.
   Wo benutzt: geladen von snippets/pp-herkunft-frage.liquid (teil 'skript') aus sections/pp-global.liquid – einmal je Seite, nur wenn das
          Metafeld packpower.herkunft_frage die Frage einschaltet (Warenkorb-Seite bzw. Seiten mit Warenkorb-Fach)
   Abschaltbar: Metafeld "anzeigen": false → das Skript wird gar nicht geladen
   Liest: <select data-pp-hf-auswahl data-pp-hf-schluessel="…"> im Kasten [data-pp-hf] (snippets/pp-herkunft-frage, teil 'frage');
          #pp-hf-daten (JSON, teil 'skript') für PP.herkunftFrageHtml(cart) – den Kasten im kleinen Warenkorb (assets/pp-minikorb.js);
          Shopify.routes.root (Sprach-Präfix, sonst „/“)
   Warum Ereignis-Delegation auf document: Horizon zeichnet Warenkorb-Seite und Fach nach Mengenänderungen per Section Rendering neu
          (morph.js) – neue Kästen bekommen so automatisch das Verhalten, ohne eigenes <script> (das liefe dort nicht).
   Braucht: nichts (unabhängig von pp-basis.js, kein import(), keine Horizon-Klassen)      Ohne Kasten: tut nichts
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-07 */
(function () {
  'use strict';
  var PP = window.PP = window.PP || {};
  if (PP.herkunftFrage) return; // schon eingerichtet (Skript doppelt eingebunden)
  PP.herkunftFrage = true;

  var AUSWAHL = 'select[data-pp-hf-auswahl]';
  var lauf = 0; // Nummer der letzten Änderung – eine ältere, später eintreffende Antwort ändert nichts mehr

  function adresse() {
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return String(wurzel).replace(/\/?$/, '/') + 'cart/update.js';
  }

  // Alle Kästen auf der Seite angleichen (Horizon kann den Kasten während des Speicherns neu gezeichnet haben – dann zeigt der neue
  // Kasten evtl. noch den alten Stand aus cart.attributes) und „Danke!“ ein- bzw. ausschalten.
  function zeigen(schluessel, wert, gespeichert) {
    var felder = document.querySelectorAll(AUSWAHL);
    for (var i = 0; i < felder.length; i++) {
      var feld = felder[i];
      if (feld.getAttribute('data-pp-hf-schluessel') !== schluessel) continue;
      if (gespeichert && feld.value !== wert) {
        var passt = false;
        for (var j = 0; j < feld.options.length; j++) if (feld.options[j].value === wert) passt = true;
        if (passt) feld.value = wert;
      }
      var kasten = feld.closest ? feld.closest('[data-pp-hf]') : null;
      if (kasten) kasten.classList.toggle('pp-hf--danke', !!(gespeichert && wert));
    }
  }

  // Kleiner Warenkorb-Kasten (assets/pp-minikorb.js, Nachtrag 07.10.2026): Er baut sich aus /cart.js und hat einen eigenen „Zur Kasse“-Knopf
  // direkt zur Kasse – ohne Frage dort fehlten diese Bestellungen in der Messung. Derselbe Kasten als HTML aus den Daten in #pp-hf-daten
  // (snippets/pp-herkunft-frage, teil 'skript'); Gestaltung kommt aus demselben <style>. Ohne Daten, ohne Warenkorb oder leer: ''.
  var daten;
  function lesen() {
    if (daten !== undefined) return daten;
    daten = null;
    try {
      var el = document.getElementById('pp-hf-daten');
      var d = el ? JSON.parse(el.textContent) : null;
      if (d && d.schluessel && d.frage && d.optionen && d.optionen.length) daten = d;
    } catch (fehler) { daten = null; }
    return daten;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (z) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z]; });
  }
  var nummer = 0;
  PP.herkunftFrageHtml = function (korb) {
    var d = lesen();
    if (!d || !korb || !korb.item_count) return '';
    var jetzt = korb.attributes && korb.attributes[d.schluessel] != null ? String(korb.attributes[d.schluessel]).trim() : '';
    var id = 'pp-hf-mini-' + (++nummer), bekannt = false, optionen = '';
    for (var i = 0; i < d.optionen.length; i++) {
      var o = String(d.optionen[i] == null ? '' : d.optionen[i]).trim();
      if (!o) continue;
      if (o === jetzt) bekannt = true;
      optionen += '<option value="' + esc(o) + '"' + (o === jetzt ? ' selected' : '') + '>' + esc(o) + '</option>';
    }
    if (jetzt && !bekannt) optionen += '<option value="' + esc(jetzt) + '" selected>' + esc(jetzt) + '</option>'; // nichts geht still verloren
    return '<div class="pp-hf pp-hf--mini" data-pp-hf>' +
      '<div class="pp-hf__kopf" aria-live="polite"><label class="pp-hf__frage" for="' + id + '">' + esc(d.frage) + '</label>' +
      (d.danke ? '<span class="pp-hf__danke">' + esc(d.danke) + '</span>' : '') + '</div>' +
      '<div class="pp-hf__feld"><select id="' + id + '" class="pp-hf__auswahl" autocomplete="off" data-pp-hf-auswahl data-pp-hf-schluessel="' + esc(d.schluessel) + '">' +
      '<option value=""' + (jetzt ? '' : ' selected') + '>' + esc(d.leer || '–') + '</option>' + optionen + '</select></div></div>';
  };

  document.addEventListener('change', function (e) {
    var feld = e.target;
    if (!feld || !feld.matches || !feld.matches(AUSWAHL)) return;
    var schluessel = feld.getAttribute('data-pp-hf-schluessel');
    if (!schluessel) return;
    var wert = String(feld.value || '');
    var nr = ++lauf;
    zeigen(schluessel, wert, false); // „Danke!“ aus, bis die neue Antwort gespeichert ist
    var attribute = {};
    attribute[schluessel] = wert; // leerer Wert („Bitte wählen“) = Antwort zurücknehmen – Shopify entfernt das Attribut
    try {
      fetch(adresse(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attribute })
      })
        .then(function (antwort) { if (!antwort.ok) throw new Error('HTTP ' + antwort.status); return antwort.json(); })
        .then(function (korb) {
          if (nr !== lauf) return; // inzwischen neu gewählt
          var jetzt = korb && korb.attributes && korb.attributes[schluessel] != null ? String(korb.attributes[schluessel]) : '';
          zeigen(schluessel, wert, jetzt === wert);
        })
        .catch(function () { /* still: keine Meldung, der Warenkorb bleibt bedienbar */ });
    } catch (fehler) { /* still (z. B. sehr alter Browser ohne fetch) */ }
  });
})();
